import React from 'react';
import { useCountUp } from './useCountUp';

interface Props {
  value: number | null | undefined;
  format?: (n: number) => string;
  duration?: number;
}

// Automatic duration scaling: larger targets animate longer so big numbers
// feel satisfyingly slow to land instead of zipping past.
function defaultDurationFor(target: number): number {
  const abs = Math.abs(target);
  if (abs < 10) return 600;
  if (abs < 100) return 750;
  if (abs < 1_000) return 900;
  if (abs < 10_000) return 1100;
  if (abs < 100_000) return 1300;
  return 1500;
}

export default function AnimatedNumber({
  value,
  format = (n: number) => Math.round(n).toLocaleString(),
  duration,
}: Props): React.ReactElement {
  const safe = value ?? 0;
  const effectiveDuration = duration ?? defaultDurationFor(safe);
  const animated = useCountUp(safe, effectiveDuration);
  if (value === null || value === undefined) return <>{'—'}</>;
  return <>{format(animated)}</>;
}
